import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "@react-navigation/native";

import Tab, { type TabProps } from "./Tab";
import DrawerMenuButton from "./DrawerMenuButton";

type HeaderProps = {
  tabs: TabProps[];
  rightComponent?: React.ReactNode;
  showBackButton?: boolean;
  previousScreenName?: string;
  showDrawerButton?: boolean;
};

function Header({
  tabs,
  rightComponent,
  showBackButton = false,
  previousScreenName,
  showDrawerButton = false,
}: HeaderProps): React.JSX.Element {
  const navigation = useNavigation();

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.container}>
        {showBackButton && (
          <View style={styles.contents}>
            <TouchableOpacity
              hitSlop={8}
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Ionicons name="arrow-back" size={24} color="black" />
              {previousScreenName && (
                <Text style={styles.previousScreenName}>
                  {previousScreenName}
                </Text>
              )}
            </TouchableOpacity>
          </View>
        )}

        {showDrawerButton && <DrawerMenuButton iconColor="black" />}

        <View style={styles.contents}>
          {tabs.map((tab, index) => (
            <Tab key={index} {...tab} />
          ))}
        </View>
        {rightComponent}
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: "#fff",
  },
  container: {
    backgroundColor: "#fff",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    height: 45,
  },
  contents: {
    flexDirection: "row",
    paddingVertical: 8,
    flex: 1,
  },
  backButton: {
    flexDirection: "row",
  },
  previousScreenName: {
    marginLeft: 10,
    color: "#000",
    fontSize: 22,
    fontWeight: "bold",
  },
});

export default Header;
